import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { getReportIssueTypeApi, reportAnIssueApi } from "../dashboard_api";
import "./report-an-issue.css";
const ReportAnIssueModal = ({ onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [validations, setvalidations] = useState({
    description: "",
    title: "",
    type: "",
  });
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "680px",

      overflowY: "auto",
    },
  };
  useEffect(() => {
    getReportIssueType();
  }, []);
  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [rejectReason, setRejectReason] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [title, setTitle] = useState("");
  const [issueTypeList, setIssueTypeList] = useState([]);
  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const getReportIssueType = async () => {
    const response = await getReportIssueTypeApi();
    if (response.success === true) {
      setIssueTypeList(response.data ?? []);
    } else {
    }
  };
  const reportIssue = async () => {
    const payload = {
      application: "Dock",
      type: selectedStatus,
      title: title,
      description: rejectReason,
    };
    try {
      const response = await reportAnIssueApi(payload);
      if (response.status === 400) {
        setvalidations({
          description: response.data.error?.description?.[0] || "",
          title: response.data.error?.title?.[0] || "",
          type: response.data.error?.type?.[0] || "",
        });
      } else {
        if (response.data.success === true) {
          onSuccess(response.data);
        } else {
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div>
            <div className="px-3 modal-header style-justify-between">
              <div className="modal-title">Report a problem</div>
              <img
                src={ModalCloseIcon}
                alt="Close"
                onClick={onCancel}
                style={{
                  cursor: "pointer",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                }}
              />
            </div>
            <div className="px-3 pb-3">
              <div
                className="form-label fs-14 fw-400 mb-1"
                style={{ color: "#21272C" }}
              >
                Issue Type
              </div>
              <div
                className="style-justify-start"
                style={{ flexWrap: "wrap", gap: "8px" }}
              >
                {issueTypeList.map((type, index) => (
                  <label
                    className={`${
                      selectedStatus === type.label
                        ? "radio-btn-txt-active"
                        : "radio-btn-txt-inactive"
                    }`}
                  >
                    <input
                      type="radio"
                      name="options"
                      value={type.label}
                      checked={selectedStatus === type.label}
                      onChange={handleChange}
                      className="custom-radio"
                    />
                    <span
                      className={`px-2 ${
                        selectedStatus === type.label
                          ? "radio-btn-txt-active"
                          : "radio-btn-txt-inactive"
                      }`}
                    >
                      {type.label}
                    </span>
                  </label>
                ))}
              </div>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                }}
              >
                {validations.type}
              </span>

              <div>
                <div
                  className="form-label fs-14 fw-400 mb-1 mt-2"
                  style={{ color: "#21272C" }}
                >
                  Title
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Enter here"
                    className="form-control rounded-3 w-100"
                    value={title}
                    onChange={(event) => {
                      setTitle(event.target.value);
                    }}
                  />
                  {/* <span className="field-error">{validations.reason}</span> */}
                </div>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.title}
                </span>
              </div>

              <div>
                <div
                  className="form-label fs-14 fw-400 mb-1 mt-2"
                  style={{ color: "#21272C" }}
                >
                  Explain your problem
                </div>
                <div>
                  <textarea
                    type="text"
                    placeholder=" "
                    className="form-control rounded-3 w-100"
                    value={rejectReason}
                    onChange={(event) => {
                      setRejectReason(event.target.value); // Update state with input value
                    }}
                  />
                  {/* <span className="field-error">{validations.reason}</span> */}
                </div>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.description}
                </span>
              </div>

              <div className="mt-3">
                <div className="style-justify-end">
                  <div
                    onClick={onCancel}
                    className="cancel-btn style-justify-center"
                  >
                    Cancel
                  </div>

                  <div
                    onClick={() => {
                      reportIssue();
                    }}
                    className="issue-submit-btn style-justify-center px-5"
                  >
                    Send report
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportAnIssueModal;
